import type { InjectionKey } from 'vue'

import type { CatalogosPersistidos } from './catalogo.tipos'

export const CHAVE_CATALOGOS_PERSISTIDOS: InjectionKey<CatalogosPersistidos> =
  Symbol('catalogos-persistidos')
